import interceptorsModule from '@/config/interceptors'

/**
 * 导航- 折叠Icon
 */
function navFoldPosition() {
  let navLogoNode = $('.r3-content-Navigator .navigator .left')
  if (navLogoNode.length && navLogoNode[0].length != 2) {
    navLogoNode.addClass('customized-navLogo')
  }

  let foldNode = $('.r3-content-Navigator .navigator .left img.trigger') // 折叠Icon
  let lefNavNode = $('.r3-horizontal-content .history-and-favorite') // 左侧导航
  let curWidth = lefNavNode.length && lefNavNode[0].style.width // 当前左导航宽度
  let baseStyle = `height: 50px; position: absolute; top: 50%; z-index: 20; margin-left: ${curWidth};`
  foldNode && foldNode.attr('style', baseStyle)
  foldNode && foldNode.attr('src', require(`assetsImg/${curWidth == '50px' ? 'icon_unfold' : 'icon_fold'}.png`))
}
/**
 * 标准列表页面- 表格/图例
 */
function legendNodeHandle() {
  let legendNode = document.getElementsByClassName('queryDesc') // 图例
  let agNode = document.getElementsByClassName('ag-grid-table-wrap') // ag表格
  let blankNodes = agNode && legendNode.length && legendNode[0].innerText === '' // 图例是否为空白节点
  $('.queryDesc').attr(
    'style',
    `display: ${ blankNodes ? 'none' : 'block'};`
  )
  $('.StandardTableListRootDiv .standardTable').attr(
    'style',
    `margin: 0 12px ${ blankNodes ? 0 : '8px'} !important; padding: 0`
  )
  if (legendNode.length && legendNode[0].style.display == 'none') {
    $('.standardTable .detailTable').attr('style', 'height: calc(100% - 46px);')
  }
}
/**
 * 标准页面 - 按钮文案处理
 */
function btnText () {
  let submitBtnNode = $('.R3-button-group #actionSUBMIT')
  if (submitBtnNode.length) {
    submitBtnNode[0].innerHTML = t('审核') // 提交 -> 审核
  }
  let unsubmitBtnNode = $('.R3-button-group #actionUNSUBMIT')
  if (unsubmitBtnNode.length) {
    unsubmitBtnNode[0].innerHTML = t('取消审核') // 取消提交 -> 取消审核
  }
}
/**
 * 标准页面 - 按钮Tip文案处理
 */
function btnTip (nodeId) {
  if (['actionSUBMIT', 'actionUNSUBMIT'].includes(nodeId)) {
    setTimeout(() => {
      let standardModalNode = $('.ark-modal-wrap .ark-modal-confirm .ark-modal-confirm-body .ark-input-wrapper')
      if (standardModalNode.length) {
        let tip = nodeId == 'actionSUBMIT'
        ? standardModalNode.text().replace('提交', '审核')
        : standardModalNode.text().replace('取消提交', '取消审核')
        standardModalNode[0].innerHTML = tip
      }
    }, 200)
  }
}

/**
 * 定制列表页面- 渲染ag表格高度
 */
function refreshAgTableHeight() {
  // 判断是否是标准页面
  let isStandardTableListNode = document.querySelector('.StandardTableListRootDiv')
  let verticalTableDetail = document.querySelector('.verticalTableDetail')
  let horizontalTableDetail = document.querySelector('.horizontalTableDetail')
  if (isStandardTableListNode || verticalTableDetail || horizontalTableDetail) return
  let bodyHeight = document.body.clientHeight
  let tableOffsetTop = 0 // ag表格与文档顶部的偏移量
  let AG_TABLE_SCROLLBAR_HEIGHT = 12 // ag滚动条高度
  let PADDING_BOTTOM_HEIGHT = 16 // 容器边距（.cus-list）
  let PADDING = 20 // 内边距
  /**
   * 兼容表格
   * 1. OmsAgTable eg：零售发货单
   * 2. Tabs-TabPane eg：线上促销活动
   */
  let agTableNode = $('.ag-grid-table-wrap') // ag表格
  let formNode = $('.list-form') // 表单搜索
  if (!agTableNode.length) return
  if (formNode.hasClass('.fold-btn-up')) return // 展开状态下不刷新

  let tabBarNode = $('.openedMenuLists') // 菜单标签页
  let btnNode = $('.list-btn') // 按钮
  let tabNode = $('.OmsLabel').length ? $('.OmsLabel') : $('.ark-tabs-bar') // 标签
  let agHeaderNode = $('.ag-header.ag-focus-managed') // ag表头
  let agFilterNode = $('.ag-header-row.ag-header-row-column-filter') // ag过滤器
  let pageNode = $('.agTable .page-wrap') // 分页
  let legendNode = $('.queryDesc') // 图例

  let tabBarHeight = tabBarNode.length ? tabBarNode[0].clientHeight : 0
  let btnHeight = btnNode.length ? btnNode[0].clientHeight + PADDING : 0
  let tabHeight = tabNode.length ? tabNode[0].clientHeight : 0
  let agHeaderHeight = agHeaderNode.length ? agHeaderNode[0].clientHeight : 0
  let agFilterHeight = agFilterNode.length ? agFilterNode[0].style.height.replace('px', '') : 0
  let pageHeight = pageNode.length ? pageNode[0].clientHeight : 0
  let descHeight = legendNode.length ? legendNode[0].clientHeight + PADDING : 0

  // 情况一：一屏无滚动条
  /* if (agTableNode.length == 1) {
    tableOffsetTop = agTableNode.offset().top
  } else {
    let listTableOffsetTop = $('.list-table').offset().top // tabs外层（list-table）与文档顶部的偏移量
    let tabpaneOffsetTop = Array.from(
      document.querySelectorAll('.list-table .ark-tabs .ark-tabs-tabpane')
    ).find(i => i.style.display == '')
      .querySelector('.ag-grid-table-wrap')
      .offsetTop // tabpane与非static的祖先元素的偏移量

    tableOffsetTop = listTableOffsetTop + tabpaneOffsetTop
  }
  let agHeight = bodyHeight - Math.ceil(tableOffsetTop) - pageHeight - descHeight */

  // 情况二：有滚动条
  // let agHeight = bodyHeight - btnHeight - pageHeight - descHeight - tabHeight - agHeaderHeight

  // 情况三：有滚动条- 页签与表格占整屏
  let agHeight = bodyHeight - tabBarHeight - btnHeight - tabHeight - agHeaderHeight + Number(agFilterHeight)

  // 文档流无分页、图例节点
  if ((!pageNode.length || pageNode.length && pageNode[0].style.display == 'none') && !legendNode.length) {
    agHeight = agHeight - PADDING_BOTTOM_HEIGHT
  }
  if (descHeight) {
    agHeight = agHeight - descHeight + 8
  }
  if (agTableNode.length > 1) {
    agHeight = agHeight - AG_TABLE_SCROLLBAR_HEIGHT
  }


  if (['ONLINEPROMOTION'].includes(vm.$route.params.customizedModuleName)) {
    // 线上促销活动
    // agHeight = 420
  }

  // 默认最小高度
  agHeight = agHeight > 0 ? parseInt(agHeight) : 220
  $('.ag-grid-table-wrap').attr('style', `height: ${ agHeight }px`)
  $('.ag-grid-table.ag-theme-balham').attr('style', `height: ${ agHeight - 2 }px`) // 兼容覆盖$utils.setTableHeight

  // console.log(agHeight);
  // console.log('bodyHeight-',bodyHeight,',btnHeight-',btnHeight,',pageHeight-',pageHeight,',descHeight-',descHeight,',tabHeight-',tabHeight,',agHeaderHeight-',agHeaderHeight);
}

// 全局按钮禁用（点击后1s内）
function globalBtnDelay(){
  $('button').click(function(e){
    let node = e.currentTarget
    let nodeId = $(this).attr('id')
    $(this).attr('disabled', 'disabled')
    btnTip(nodeId)
    setTimeout(function () {
      $(node).removeAttr('disabled')
    }, 1000)
  })
}

/**
 * 全局-关闭浏览器的地址自动填充
 */
function closeBrowserAutocomplete(){
  $('.el-input input').each(function(index, item){
    item.attributes[1].value = 'new-password'
  })
}

/**
 * 浏览器样式兼容：
 */
function browserCssCompatible() {
  const { userAgent } = window.navigator
  let browser = ''
  const bro = ['Safari', 'Firefox']
  bro.forEach(i => {
    if (userAgent.includes(i)) {
      browser = i
      return
    }
  })
  $("body").addClass(browser);
}

/**
 * fix: chrome浏览器116兼容 input disabled click
 *
 * 1. 下拉单/多选，点击input框而非下拉图标时，fktable不会弹出来了
 * 2. 不能在disabled的input上直接加 pointer-events: none; 会导致普通input在disable状态时无法光标选中并复制其中的文本内容
 *
 */
function fkInputClick() {
  $('.ark-fkrp-select-autocomplete')
  .css('cursor', 'zoom-in')
  .find('.ark-input-disabled')
  .css('pointer-events', 'none')
}

// mop 弹窗多选 由于模糊搜索入参问题 特此禁用输入功能 (框架bug 需要提)
function disableMopInputFk(){
  fkInputClick()
  const options = [
    {
      // 订单打标策略-单对象, 店铺、
      tablename: 'ST_C_ORDER_LABEL',
      colnames: ['SHOP_IDS']
    }
  ]
  options.forEach(it => {
    const p = it.tablename
    const c = it.colnames
    if (c.length) {
      c.forEach(x => {
        $(`#${p} #${x} input`).attr('disabled', 'disabled')
        $(`#${p} #${x} .fkrp-poptip-text i`).click(() => {
          // fix: 点击clear图标之后disabled又不行了
          setTimeout(() => {
            $(`#${p} #${x} input`).attr('disabled', 'disabled')
          }, 10);
        })
      })
    }
  })
}

// iframe弹窗仅展示内容区域
function iframeStyle() {
  if (vm.$route.query.iframe) {
    vm.$store.commit('customize/setIsModalIframe', vm.$route.query.iframe === "true");
    Vue.nextTick(() => {
      $('.NavigatorVertical.transferRight').attr('style', 'display: none')
      $('.r3-content-nav').attr('style', 'display: none')
      setTimeout(() => { $('.openedMenuLists').attr('style', 'display: none') }, 500)
      $('body').addClass('is-modal-iframe')
      if (vm.$route.query.page_readonly) {
        $('body').addClass('is-modal-iframe-readonly')
      }
      const disableDom = function () {
        $('.iframe-main input').each(function() {
          $(this).attr('disabled', true);
        })
        $('.iframe-main button').each(function() {
          $(this).attr('disabled', true);
        })
        $('.iframe-main .ark-input').addClass('ark-input-disabled')
        $('.iframe-main .ark-switch').addClass('ark-switch-disabled')
        $('.iframe-main .ark-select').addClass('ark-select-disabled')
        $('.ark-fkrp-select-autocomplete').each(function() {
          $(this).removeClass('ark-fkrp-select-autocomplete');
        })
      }
      setTimeout(() => {
        disableDom()
      }, 3000);
      setTimeout(() => {
        disableDom()
      }, 6000);
    })
  }
}

// 店铺策略-默认退货仓库pop定位
function CP_C_WAREHOUSE_DEF_ID_PoperPosition(currentTable) {
  if (currentTable == 'ST_C_SHOP_STRATEGY') {
    setTimeout(() => {
      $('body')[0].style.position = 'initial'; // fix:店铺策略单对象最下面的fktable被截断
    }, 1000)
  } else {
    setTimeout(() => {
      $('body')[0].style.position = 'absolute'; // fix:双开fktable会闪
    }, 1000)
  }
}

// 覆盖表格序号列高度
function resetIndexColumnHeight(tableClassName) {
  let overflow = $(`${'.'+tableClassName || ''}.jordan-table-box .ark-table-body`).css('overflow-y')
  if (overflow == 'auto') {
    let bodyHeight = $(`${'.'+tableClassName || ''}.jordan-table-box .ark-table-body`).height()
    let scrollHeight = 12 // 滚动条高度
    $(`${'.'+tableClassName || ''}.jordan-table-box .ark-table-fixed .ark-table-fixed-body`).attr('style', `height: ${bodyHeight - scrollHeight}px`)
  }
}


// js 样式方法集
export default {
  disableMopInputFk,
  closeBrowserAutocomplete,
  browserCssCompatible,
  navFoldPosition,
  legendNodeHandle,
  btnText,
  refreshAgTableHeight,
  globalBtnDelay,
  iframeStyle,
  CP_C_WAREHOUSE_DEF_ID_PoperPosition,
  resetIndexColumnHeight
};
